import { render, staticRenderFns } from "./GreetingMission.vue?vue&type=template&id=56b1cd3c&scoped=true&"
import script from "./GreetingMission.vue?vue&type=script&lang=js&"
export * from "./GreetingMission.vue?vue&type=script&lang=js&"
import style0 from "./GreetingMission.vue?vue&type=style&index=0&id=56b1cd3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b1cd3c",
  null
  
)

export default component.exports